<template>
  <div class="lens-gpt-development">
    <section class="lens-gpt-development__card" aria-labelledby="lens-gpt-development-title">
      <div class="lens-gpt-development__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 18.5H6.5A3.5 3.5 0 0 1 3 15V8.5A3.5 3.5 0 0 1 6.5 5h11A3.5 3.5 0 0 1 21 8.5V15a3.5 3.5 0 0 1-3.5 3.5H12l-4 3v-3Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          <path d="m16.75 2 .34 1.04c.15.46.51.82.97.97l1.04.34-1.04.34c-.46.15-.82.51-.97.97l-.34 1.04-.34-1.04a1.5 1.5 0 0 0-.97-.97l-1.04-.34 1.04-.34c.46-.15.82-.51.97-.97L16.75 2Z" fill="currentColor" />
          <path d="M7.5 11.75h.01M12 11.75h.01M16.5 11.75h.01" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
        </svg>
      </div>

      <p class="lens-gpt-development__status">Development in progress</p>
      <h1 id="lens-gpt-development-title">LENS GPT is coming soon</h1>
      <p class="lens-gpt-development__message">
        This feature is currently under development and is not yet available. Our team is working to deliver a reliable and secure experience.
      </p>
      <p class="lens-gpt-development__note">Thank you for your patience.</p>

      <router-link class="lens-gpt-development__button" to="/">
        <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="m8.25 5-5 5 5 5M3.25 10h13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Back to Dashboard
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LensGptDevelopment'
}
</script>

<style scoped>
.lens-gpt-development {
  display: grid;
  min-height: calc(100vh - 10rem);
  place-items: center;
  padding: 3rem 1.5rem;
  background:
    radial-gradient(circle at 18% 20%, rgba(255, 103, 31, 0.08), transparent 25rem),
    radial-gradient(circle at 85% 75%, rgba(20, 115, 91, 0.08), transparent 25rem),
    #f7f9f8;
}

.lens-gpt-development__card {
  width: min(100%, 40rem);
  padding: 3.5rem 3rem;
  border: 1px solid #dbe5e1;
  border-top: 0.3rem solid #ff671f;
  border-radius: 0;
  background: #ffffff;
  box-shadow: 0 1.25rem 3rem rgba(17, 70, 57, 0.1);
  text-align: center;
}

.lens-gpt-development__icon {
  display: inline-grid;
  width: 4.75rem;
  height: 4.75rem;
  margin-bottom: 1.4rem;
  place-items: center;
  color: #ff671f;
  background: #fff1ea;
  border: 1px solid #ffd8c5;
  border-radius: 50%;
}

.lens-gpt-development__icon svg {
  width: 2.7rem;
  height: 2.7rem;
}

.lens-gpt-development__status {
  margin: 0 0 0.75rem;
  color: #df5212;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.lens-gpt-development h1 {
  margin: 0;
  color: #123f46;
  font-size: clamp(1.85rem, 4vw, 2.6rem);
  font-weight: 800;
  line-height: 1.15;
}

.lens-gpt-development__message {
  max-width: 32rem;
  margin: 1.25rem auto 0;
  color: #52666a;
  font-size: 1rem;
  line-height: 1.65;
}

.lens-gpt-development__note {
  margin: 0.7rem 0 0;
  color: #52666a;
  font-size: 0.9rem;
  font-weight: 600;
}

.lens-gpt-development__button {
  display: inline-flex;
  min-height: 2.85rem;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  margin-top: 2rem;
  padding: 0.7rem 1.25rem;
  border: 1px solid #174f58;
  border-radius: 0;
  color: #ffffff;
  background: #174f58;
  font-weight: 700;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.lens-gpt-development__button svg {
  width: 1.15rem;
  height: 1.15rem;
}

.lens-gpt-development__button:hover,
.lens-gpt-development__button:focus {
  border-color: #0f3e45;
  color: #ffffff;
  background: #0f3e45;
  box-shadow: 0 0.6rem 1.2rem rgba(23, 79, 88, 0.18);
}

:global(.deluxe-layout.dark) .lens-gpt-development {
  background:
    radial-gradient(circle at 18% 20%, rgba(255, 103, 31, 0.12), transparent 25rem),
    radial-gradient(circle at 85% 75%, rgba(46, 158, 126, 0.12), transparent 25rem),
    #151a19;
}

:global(.deluxe-layout.dark) .lens-gpt-development__card {
  border-color: #36423f;
  border-top-color: #ff7b3d;
  background: #1f2624;
  box-shadow: 0 1.25rem 3rem rgba(0, 0, 0, 0.3);
}

:global(.deluxe-layout.dark) .lens-gpt-development h1 {
  color: #f7faf9;
}

:global(.deluxe-layout.dark) .lens-gpt-development__message,
:global(.deluxe-layout.dark) .lens-gpt-development__note {
  color: #b8c6c2;
}

@media (max-width: 575.98px) {
  .lens-gpt-development {
    min-height: calc(100vh - 8rem);
    padding: 1.5rem 0.75rem;
  }

  .lens-gpt-development__card {
    padding: 2.5rem 1.25rem;
  }
}
</style>
